import axiosClientCached from '@lib/axiosClientCached.ts';
import { processStoreError } from '@lib/errorHandler';
import { createAsyncThunk } from '@reduxjs/toolkit';
import type { AppState } from '@store/appStore.ts';
import { selectIsLoggedIn } from '@store/reducers/meReducer.ts';
import dayjs from 'dayjs';

export let extraLastChecked = dayjs().subtract(1, 'hour').toISOString();

// Ignore this one as its odd an unlikely a pattern you will ever need to use!!!
export const meCheckIfLoggedIn = createAsyncThunk('me/check', async (_, { rejectWithValue, getState }) => {
  if (dayjs().diff(extraLastChecked, 'seconds') < 1) {
    const isLoggedIn = selectIsLoggedIn(getState() as AppState);
    if (!isLoggedIn) {
      throw rejectWithValue({
        error: {
          statusCode: 401,
          message: 'Unauthorized (Cache Check)',
        },
      });
    }
    return true;
  }
  extraLastChecked = dayjs().toISOString();
  let apiResultPayload;
  try {
    const response = await axiosClientCached.get('/me/check');
    apiResultPayload = response.data; // Successfully fetched
  } catch (e: unknown) {
    const processed = processStoreError(e); // Use the new library function

    if (processed.statusCode === 401) {
      const errorDetail = { statusCode: 401, data: processed.data, message: 'Unauthorized (API 401)' };
      throw rejectWithValue({ error: errorDetail });
    } else {
      console.error(
        "meCheckIfLoggedIn: Non-401 error during /me/check. Swallowing to prevent logout. User's loggedIn status might be incorrectly set to true if they were logged out.",
        { message: processed.message, status: processed.statusCode, data: processed.data },
      );
      apiResultPayload = {
        __swallowedError: true,
        details: { message: processed.message, status: processed.statusCode },
      };
    }
  }
  return apiResultPayload;
});
